import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE = "paginationCampaignAnnounceRewardMessage";
export const GET_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE = "getCampaignAnnounceRewardMessage";
export const CREATE_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE = "createCampaignAnnounceRewardMessage";

// mutation types
export const SET_PAGINATION_MESSAGE = "setPaginationMessage";
export const SET_IS_CLEAR_PAGINATION_MESSAGE = "setIsClearPaginationMessage";
export const CLEAR_PAGINATION_MESSAGE = "clearPaginationMessage";

export default {
  state: {
    path: "campaign_announce_reward_message",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: false,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [GET_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`, {
        params: payload.params
      });
    },
    [CREATE_CAMPAIGN_ANNOUNCE_REWARD_MESSAGE](context, payload) {
      ApiService.setHeader();
      return ApiService.post(
        `${context.state.path}`,
        payload.data
      );
    }
  },
  mutations: {
    [SET_PAGINATION_MESSAGE](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION_MESSAGE](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION_MESSAGE](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: false,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
